import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { IUserSessionComponentProps, UserSessionViewModelKey } from '../../../../models/AppState';
import { AutoCompleteSearchField } from '../../../../web/components/autocomplete/AutoCompleteSearchField';
import { SearchIcon } from '../../../../web/components/svgs/icons/SearchIcon';
import { styleSheet } from './styles';

interface IProps extends RouteComponentProps<any>, IUserSessionComponentProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

class _BookOfBusinessSection extends React.Component<IProps> {
	public render() {
		const { className, styles } = this.props;
		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} book-of-business-section ${className || ''}`}>
				<div className={css(styleSheet.topContainer)}>
					<svg className={css(styleSheet.book)} width='317' height='229' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							opacity='.1'
							d='M273.328 131.446c-9.98 16.352-8.215 38.563-3.939 56.077 1.431 5.864 3.084 12.048 1.811 18.619-1.557 8.034-7.135 14.367-12.769 17.992-10.272 6.612-21.967 6.477-30.437-.349-7.331-5.9-12.13-16.221-19.608-21.801-12.529-9.339-29.784-3.571-44.795 5.278-10.621 6.257-22.309 14.177-32.076 9.764-6.871-3.105-11.121-11.931-13.09-21.548-.949-4.642-1.51-9.714-3.714-13.248-1.311-2.099-3.12-3.501-4.996-4.647-17.124-10.459-40.387-1.554-56.89-13.409-11.148-8.007-17.437-24.612-19.448-42.39-2.01-17.777-.231-36.822 1.987-55.573C36.951 52.889 39.081 38.62 46 27.758 53.316 16.266 64.8 11.1 74.757 12.129c9.956 1.03 18.578 7.43 26 15.247 9.277 9.77 17.624 22.264 29.67 25.375 8.194 2.12 17.185-.413 25.915-1.862 14.595-2.422 28.973-1.806 43.244-.982 13.664.789 27.413 1.791 40.13 6.635 8.999 3.428 15.885 10.615 24.276 15.27 5.47 3.036 11.654 3.396 16.746 7.454 6.272 4.985 11.677 14.25 9.108 25.982-2.444 11.157-11.224 17.523-16.518 26.199z'
							fill='#6C63FF'
						/>
						<path
							d='M86.7 81.453S43.33 71.753 98.514 15c0 0 23.787 22.552 15.063 50.585-3.508 11.271-14.797 18.23-26.234 16l-.643-.132z'
							fill='#FFCFF0'
						/>
						<path d='M87.5 81s22.035-34.119 10.816-66' stroke='#535461' />
						<path
							d='M263.944 114s-7.55-29.84 3.89-51.084c4.805-8.916 6.713-19.073 5.109-29.035A77.156 77.156 0 00269.329 20'
							stroke='#535461'
							strokeWidth='2'
						/>
						<path
							d='M276.498 6.86c-.154 3.7-7.097 14.14-7.097 14.14s-6.052-11.014-5.898-14.714c.222-3.645 3.232-6.436 6.771-6.28 3.539.157 6.306 3.204 6.224 6.854zm10.693 20.5C285.069 30.285 273.5 35 273.5 35s.741-12.228 2.863-15.15c1.35-1.948 3.673-3.029 6.071-2.826 2.398.204 4.495 1.66 5.482 3.804a6.367 6.367 0 01-.727 6.533h.002zm-2.376 34.022c-3.245 1.478-15.315-.16-15.315-.16s6.759-10.213 10.005-11.694c3.23-1.397 6.975.07 8.422 3.3 1.446 3.23.063 7.034-3.112 8.554zm-7.081 26.215C274.76 89.567 262.5 90 262.5 90s4.987-10.997 7.961-12.97c2.971-1.894 6.942-1.103 8.925 1.778 1.984 2.882 1.249 6.792-1.652 8.79zm-18.545-52.451C261.648 37.823 273.5 41 273.5 41s-2.421-12.329-4.88-15.003a6.367 6.367 0 00-9.087-.177c-2.571 2.493-2.723 6.64-.344 9.326zm-8.422 29.634c3.206 1.695 15.733 1.13 15.733 1.13s-6.035-10.472-9.244-12.176c-3.192-1.605-7.147-.492-8.909 2.507-1.762 3-.688 6.79 2.42 8.538zm-2.99 30.53C250.523 97.533 262.5 99 262.5 99s-3.944-11.441-6.689-13.655a6.383 6.383 0 00-8.891 1.036 6.419 6.419 0 00.857 8.93z'
							fill='#6C63FF'
						/>
						<path
							d='M276.498 6.86c-.154 3.7-7.097 14.14-7.097 14.14s-6.052-11.014-5.898-14.714c.222-3.645 3.232-6.436 6.771-6.28 3.539.157 6.306 3.204 6.224 6.854zm10.693 20.5C285.069 30.285 273.5 35 273.5 35s.741-12.228 2.863-15.15c1.35-1.948 3.673-3.029 6.071-2.826 2.398.204 4.495 1.66 5.482 3.804a6.367 6.367 0 01-.727 6.533h.002zm-2.376 34.022c-3.245 1.478-15.315-.16-15.315-.16s6.759-10.213 10.005-11.694c3.23-1.397 6.975.07 8.422 3.3 1.446 3.23.063 7.034-3.112 8.554zm-7.081 26.215C274.76 89.567 262.5 90 262.5 90s4.987-10.997 7.961-12.97c2.971-1.894 6.942-1.103 8.925 1.778 1.984 2.882 1.249 6.792-1.652 8.79zm-18.545-52.451C261.648 37.823 273.5 41 273.5 41s-2.421-12.329-4.88-15.003a6.367 6.367 0 00-9.087-.177c-2.571 2.493-2.723 6.64-.344 9.326zm-8.422 29.634c3.206 1.695 15.733 1.13 15.733 1.13s-6.035-10.472-9.244-12.176c-3.192-1.605-7.147-.492-8.909 2.507-1.762 3-.688 6.79 2.42 8.538zm-2.99 30.53C250.523 97.533 262.5 99 262.5 99s-3.944-11.441-6.689-13.655a6.383 6.383 0 00-8.891 1.036 6.419 6.419 0 00.857 8.93z'
							fill='#FC6681'
						/>
						<path
							d='M237.5 95s31.253-26.197 38.2-39.408C282.646 42.38 291.5 31 291.5 31'
							stroke='#535461'
							strokeWidth='2'
						/>
						<path d='M286.5 60.905L273.5 58s3.063 13.585 13 2.905z' fill='#00AAE8' />
						<path
							d='M266.579 46l7.921 11.975S259.022 59.111 266.579 46zm25.921 4.185L280.5 48s7.541 11.898 12 2.185zM274.638 40l5.862 7.965s-10.377 1.016-5.862-7.965zm11.862-2s10.497.532 11.712 1.597c1.215 1.065-1.563 7.31-5.563 6.291-4-1.018-6.149-7.888-6.149-7.888zm-4.111-10s4.267 8.003 4.107 9.525c-.161 1.522-6.501 3.233-7.784-2.537-1.283-5.77 3.677-6.988 3.677-6.988z'
							fill='#00AAE8'
						/>
						<path d='M296.219 33.692a2.93 2.93 0 10-5.584-1.77 2.928 2.928 0 105.584 1.77z' fill='#FFD037' />
						<path d='M291.637 30.701a2.928 2.928 0 10-5.584-1.77 2.928 2.928 0 105.584 1.77z' fill='#FFD037' />
						<path
							d='M97.756 102s12.572-9.388-3.216-42.246c0 0-21.052-26.11 0-50.754 0 0-45.905 1.174-45.028 44.006C50.39 95.84 72.465 102 72.465 102h25.29z'
							fill='#046CB6'
						/>
						<path
							d='M85.843 102s-3.214-22.588-11.82-36.375a29.375 29.375 0 01-3.618-9.018c-2.876-12.505 1.226-25.582 10.518-34.532L94.5 9'
							stroke='#00AAE8'
							strokeWidth='2'
						/>
						<path
							d='M123.211 26s2.803 3.85-1.294 9.66c-4.097 5.812-7.474 10.728-6.109 14.34 0 0 6.18-10.793 11.211-10.945 5.031-.152 1.725-6.565-3.808-13.055z'
							fill='#6C63FF'
						/>
						<path
							opacity='.1'
							d='M123.142 26c.245.372.438.778.574 1.207 4.964 6.055 7.607 11.708 2.838 11.85-4.445.132-9.777 8.386-11.054 10.47.042.16.093.318.152.473 0 0 6.25-10.793 11.338-10.945 5.088-.152 1.748-6.565-3.848-13.055z'
							fill='#000'
						/>
						<path
							d='M129.5 31.784c0 1.225-.224 2.216-.5 2.216s-.5-.994-.5-2.216c0-1.223.281-.65.557-.65s.443-.573.443.65z'
							fill='#FFD037'
						/>
						<path
							d='M130.787 33.008c-1.174.705-2.193 1.13-2.281.951-.088-.178.79-.893 1.961-1.599 1.172-.705.711-.19.799 0 .088.191.693-.058-.479.648z'
							fill='#FFD037'
						/>
						<path
							d='M107.79 26s-2.803 3.85 1.294 9.66c4.097 5.812 7.473 10.728 6.108 14.34 0 0-6.179-10.793-11.21-10.945-5.03-.152-1.731-6.565 3.808-13.055z'
							fill='#6C63FF'
						/>
						<path
							opacity='.1'
							d='M107.862 26a4.839 4.839 0 00-.573 1.207c-4.962 6.055-7.604 11.708-2.837 11.85 4.443.132 9.772 8.386 11.048 10.47-.042.16-.093.318-.152.473 0 0-6.255-10.796-11.34-10.942-5.086-.146-1.744-6.568 3.854-13.058z'
							fill='#000'
						/>
						<path
							d='M102.5 31.784c0 1.225.224 2.216.5 2.216s.5-.994.5-2.216c0-1.223-.281-.65-.557-.65s-.443-.573-.443.65z'
							fill='#FFD037'
						/>
						<path
							d='M101.213 33.008c1.174.705 2.193 1.13 2.281.951.088-.178-.79-.893-1.961-1.599-1.172-.705-.711-.19-.799 0-.088.191-.693-.058.479.648z'
							fill='#FFD037'
						/>
						<path
							d='M316.5 189.311l-25.67-113.21h-9.537c-.381-4.326-.636-8.517-.732-12.464 0 0-34.574 7.583-62.146-14.355-27.571-21.939-59.985 1.897-59.985 1.897l-.126-.091v-.044.056c-2.251-1.598-33.303-22.928-59.851-1.8-27.56 21.938-62.146 14.355-62.146 14.355-.096 3.997-.354 8.223-.744 12.59h-8.848L.5 189.72s106.564 4 143.907.311c1.339 2.837 7.111 4.969 14.026 4.969 7.77 0 14.09-2.693 14.31-6.05 29.068 2.217 91.618 5.762 143.757.361z'
							fill='url(#paint0_linear)'
						/>
						<path
							d='M30.13 77.129L4.5 187.62s141.09 5.275 152.452-2.108c0 0 87.588 8.834 156.548 1.714L288.4 77l-258.27.129z'
							fill='#E2E2EC'
						/>
						<path
							opacity='.1'
							d='M38.388 81.123L14.5 184.768s131.502 4.948 142.091-1.977c0 0 81.635 8.286 145.909 1.607L279.098 81l-240.71.123z'
							fill='#000'
						/>
						<path
							d='M278.371 65.166s-33.805 7.432-60.743-14.069c-26.937-21.501-58.631 1.858-58.631 1.858s-31.69-23.359-58.628-1.858-60.743 14.07-60.743 14.07C38.561 108.433 18.5 178.51 18.5 178.51s36.973 10.086 85.832-10.351c48.859-20.437 54.668 7.167 54.668 7.167s5.809-27.606 54.668-7.167c48.859 20.44 85.832 10.351 85.832 10.351s-20.073-70.077-21.129-113.343z'
							fill='#F1F2FB'
						/>
						<path opacity='.1' d='M93.5 175.4s44.639-9.714 65.232 4.6c0 0 19.81-17.382 65.768-3.833' fill='#000' />
						<path d='M158.5 193c7.732 0 14-2.686 14-6s-6.268-6-14-6-14 2.686-14 6 6.268 6 14 6z' fill='#E8EAF8' />
						<path opacity='.1' d='M158.5 53s11.054 51.052.29 123l-.29-123z' fill='#000' />
						<path
							opacity='.1'
							d='M48.5 80.765s21.06 5.029 39.29 0 51.701-21.479 62.71 0m-102 8.965s21.06 5.108 39.29 0c18.23-5.11 57.702-4.835 62.71 0m-102 16.035s21.06 5.029 39.29 0 51.701-21.479 62.71 0m-102 8.964s21.06 5.109 39.29 0 57.702-4.833 62.71 0m118-33.964s-21.061 5.029-39.29 0c-18.23-5.029-51.701-21.479-62.71 0m102 8.965s-21.061 5.108-39.29 0c-18.23-5.11-57.702-4.835-62.71 0m102 16.035s-21.061 5.029-39.29 0c-18.23-5.029-51.701-21.479-62.71 0m102 8.964s-21.061 5.109-39.29 0c-18.23-5.109-57.702-4.833-62.71 0'
							stroke='#000'
							strokeWidth='4'
						/>
						<path
							d='M269.479 210.47c.873-.646 1.703-1.411 1.957-2.335.269-1.018-.331-2.063-1.366-2.377-1.255-.378-2.595.308-3.614 1.002-1.019.695-2.181 1.488-3.512 1.341 1.378-.965 2.039-2.541 1.654-3.952a1.513 1.513 0 00-.46-.805c-.696-.59-1.96-.336-2.792.127-2.653 1.477-3.393 4.325-3.407 6.892-.268-.926-.041-1.889-.05-2.84-.009-.952-.335-2.002-1.348-2.513a4.936 4.936 0 00-2.056-.381c-1.191-.034-2.522.059-3.334.751-1.011.847-.749 2.295.131 3.238.879.943 2.219 1.536 3.451 2.188.94.497 1.889 1.076 2.466 1.861.074.104.135.216.183.333h7.475a21.69 21.69 0 004.622-2.53z'
							fill='#00AAE8'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M217.043 104.977s.073.422.196 1.172a9.807 9.807 0 01-.196.349c-2.389 4.047-2.756 9.876-2.532 14.661a48.29 48.29 0 002.002 11.376 53.462 53.462 0 012.04 14.778 10.66 10.66 0 003.345 2.451l.049.148c.048.148.097.296.141.439a60.324 60.324 0 012.223 11.321l.752 9.576s5.761 21.674 7.512 25.706c1.247 2.867.973 8.796.711 11.974-.749 2.138-1.661 4.176-2.465 4.398-1.457.417-2.914 3.947-.793 5.721.159.133.33.25.51.352l.085.047.154.079.227.102.117.044.242.083.105.032c.113.032.23.064.355.094a6.333 6.333 0 004.325-.689c1.597-.241 3.016-1.103 4.079-1.974l-.029 1.528h1.749l-.082-3.052c.315-.355.49-.587.49-.587s.052-1.844.253-3.99l-.128 6.887h1.748l-.472-12.711c.088-.19.205-.365.347-.519 1.457-1.466-1.061-6.195-2.363-6.984.286-1.529.971-3.393 1.897-5.918.956-2.605 2.171-5.914 3.473-10.285 3.756-12.608-1.002-24.949-1.002-24.949v-9.676c1.262-.545 2.005-.917 2.005-.917s-1.749-10.333 0-17.64c1.133-4.724 1.427-8.919.48-12.933a733.006 733.006 0 012.276-7.732l1.749-18.144c.445-2.724.746-5.055.938-7.037a9.29 9.29 0 00.067-.742c.321-3.692.251-6.157.041-7.77.102-.74.137-1.486.105-2.232.04-.382.056-.767.046-1.152.251-.293.496-.586.729-.88a12.662 12.662 0 001.57-2.521c1.927-3.656 1.982-8.122-.708-11.344-.938-1.126-1.511-2.3-2.091-3.492-.443-.91-.891-1.83-1.51-2.745-1.221-1.806-1.519-3.947-1.809-6.036v-.002l-.062-.445a79.888 79.888 0 00-1.603-8.23c-.126-.499-.604-.877-1.078-1.253-.284-.225-.567-.449-.772-.697-.814-.985-2.828-1.187-4.525-1.357a24.13 24.13 0 01-1.402-.165c-2.99-.478-6.228-.923-8.949.258-1.521.662-2.698 1.758-3.87 2.85-.287.267-.574.535-.865.795-.632.563-1.525 1.01-2.405 1.452-1.342.673-2.654 1.33-2.96 2.36-.452.65-.475 1.466.291 2.556.643.912 1.607 1.598 2.561 2.277a63.158 63.158 0 01.581.419c.086.064.171.127.259.184-.756 4.645 1.591 9.243 5.784 11.33-.029.19-.061.378-.096.562a34.17 34.17 0 01-1.317 4.841c-.324.974-4.065 2.674-6.702 3.765a3.354 3.354 0 00-1.07-.742c-2.005-.504-8.765 3.275-9.266 4.536-.14.352.227 1.325.824 2.551.04.558.131 1.112.271 1.654-.148 2.58.12 6.744 1.411 13.438l2.007 18.396zm28.121 2.835c-.094-.179-.19-.361-.292-.548-2.783-5.662-4.435-14.816-.449-20.276.356.038.711.073 1.067.097.236 7.43.099 19.645.099 19.645s-.157.41-.425 1.082zm-8.084 52.355c-.621-3.02-1.285-6.342-1.85-9.2l-.105-.484c-.373.074-.749.143-1.128.208l.035.513.548 12.505 2.354 7.108c.835-3.495.884-7.133.146-10.65z'
							fill='url(#paint1_linear)'
						/>
						<path
							d='M236.804 159.094a23.063 23.063 0 01-.148 10.462 13.154 13.154 0 01-.603 1.917l.688 27.131.078 3.075c.638.13 1.283.222 1.931.276.602.06 1.209.06 1.811 0 .603-.074 1.135-.249 1.418-.586.284-.336.344-.878-.057-1.665a4.828 4.828 0 01-.492-2.795c.024-.269.069-.553.124-.846.603-3.052 2.857-7.466 5.474-15.918 3.829-12.38-1.02-24.511-1.02-24.511v-11.396L233.5 143s.604 3.067 1.433 7.053c.562 2.81 1.237 6.073 1.871 9.041z'
							fill='#FDC2CC'
						/>
						<path
							opacity='.1'
							d='M236.804 159.094a23.063 23.063 0 01-.148 10.462 13.154 13.154 0 01-.603 1.917l.688 27.131.078 3.075c.638.13 1.283.222 1.931.276.602.06 1.209.06 1.811 0 .603-.074 1.135-.249 1.418-.586.284-.336.344-.878-.057-1.665a4.828 4.828 0 01-.492-2.795c.024-.269.069-.553.124-.846.603-3.052 2.857-7.466 5.474-15.918 3.829-12.38-1.02-24.511-1.02-24.511v-11.396L233.5 143s.604 3.067 1.433 7.053c.562 2.81 1.237 6.073 1.871 9.041z'
							fill='#000'
						/>
						<path
							d='M220.5 144a36.796 36.796 0 012.055 5.229 57.993 57.993 0 012.245 11.143l.76 9.429s5.82 21.334 7.59 25.305c1.259 2.824.984 8.659.718 11.794a57.777 57.777 0 01-.212 2.1l2.581-3.1 3.382-4.067 1.543-1.856.338-.405a15.05 15.05 0 01-.987-2.59 43.53 43.53 0 01-1.54-8.313c-.76-7.69-1.011-18.112-1.011-18.112l-.401-1.173-2.392-7.012-.553-12.316-.207-4.56L220.5 144z'
							fill='#FDC2CC'
						/>
						<path
							d='M239.514 197.677a17.46 17.46 0 00-2.909 5.764c-.778 2.651-2.145 6.726-3.293 7.053-1.712.49-3.424 5.394.977 6.376 4.401.982 8.073-3.924 8.073-3.924s.246-8.581 1.712-10.05c1.466-1.469-1.223-6.376-2.446-6.866-.489-.2-1.316.612-2.114 1.647z'
							fill='#5F5D7E'
						/>
						<path
							opacity='.1'
							d='M232.784 216.138a5.91 5.91 0 003.447-.313 7.699 7.699 0 004.823-6.613c.209-2.627.65-6.158 1.546-7.054 1.161-1.16-.29-4.465-1.538-6.045a.668.668 0 01.555-.087c1.227.49 3.928 5.396 2.454 6.868-1.474 1.473-1.717 10.055-1.717 10.055s-3.677 4.906-8.096 3.92a4.067 4.067 0 01-1.758-.809c.093.029.186.055.284.078z'
							fill='#000'
						/>
						<path
							d='M243.949 203.448L244.5 216h-2l.277-12.543c.016-.263.278-.466.588-.457.305-.008.563.19.584.448z'
							fill='#5F5D7E'
						/>
						<path
							opacity='.15'
							d='M243.949 203.448L244.5 216h-2l.277-12.543c.016-.263.278-.466.588-.457.305-.008.563.19.584.448z'
							fill='#000'
						/>
						<path
							d='M237.514 198.678a17.46 17.46 0 00-2.909 5.764c-.778 2.651-2.145 6.725-3.293 7.053-1.712.49-3.424 5.393.977 6.375 4.401.982 8.073-3.929 8.073-3.929s.246-8.581 1.712-10.05c1.466-1.469-1.223-6.375-2.446-6.865-.495-.182-1.316.617-2.114 1.652z'
							fill='#5F5D7E'
						/>
						<path
							opacity='.1'
							d='M230.787 217.134a5.906 5.906 0 003.446-.313 7.694 7.694 0 004.821-6.612c.209-2.626.65-6.157 1.547-7.052 1.16-1.16-.29-4.464-1.538-6.044a.667.667 0 01.554-.087c1.227.49 3.928 5.394 2.454 6.867-1.473 1.472-1.714 10.053-1.714 10.053s-3.681 4.904-8.099 3.925a4.073 4.073 0 01-1.758-.809c.104.029.189.055.287.072z'
							fill='#000'
						/>
						<path
							d='M241.953 204.449L242.5 217h-2l.275-12.543c.016-.263.276-.466.584-.456.308-.015.572.185.594.448z'
							fill='#5F5D7E'
						/>
						<path
							opacity='.15'
							d='M241.953 204.449L242.5 217h-2l.275-12.543c.016-.263.276-.466.584-.456.308-.015.572.185.594.448z'
							fill='#000'
						/>
						<path
							d='M220.5 66.874l9.737 15.636 11.44 1.49s7.059-14.146 6.817-14.89c-.242-.746-3.896-2.233-7.303-4.964-3.407-2.732.731-14.146.731-14.146l-11.196.992c.043.152.086.293.118.463.446 1.927.288 4.066-.055 5.946a33.94 33.94 0 01-1.283 4.759c-.486 1.487-9.006 4.714-9.006 4.714z'
							fill='#FDC2CC'
						/>
						<path
							opacity='.1'
							d='M234.5 143s.579 3.044 1.375 7a56.064 56.064 0 0010.625-3.404v-2.367l-12-1.229zm-14 1a41.626 41.626 0 012.037 5.624c3.491 1.675 7.832 1.628 11.963.88l-.205-4.905L220.5 144z'
							fill='#000'
						/>
						<path
							d='M217.009 106.257c-2.373 3.965-2.738 9.668-2.515 14.371a46.62 46.62 0 001.989 11.138 51.666 51.666 0 012.029 14.473c8.46 9.131 29.362-1.234 29.362-1.234s-1.741-10.117 0-17.276c1.212-4.977 1.471-9.362.241-13.563a21.268 21.268 0 00-2.479-5.441c-.33-.519-.65-1.094-.959-1.709-2.883-5.782-4.548-15.28.088-20.52a9.648 9.648 0 011.618-1.459c4.042-2.903 5.883-6.126 6.659-8.854a11.81 11.81 0 00.295-5.213c-.498-2.716-7.466-5.184-7.466-5.184.25 8.145-10.201 15.053-10.201 15.053s-11.945-15.301-13.934-15.794c-1.988-.493-8.709 3.209-9.207 4.443-.497 1.234 5.475 10.365 5.475 10.365s3.735 18.507-.995 26.404z'
							fill='#D39999'
						/>
						<path
							opacity='.1'
							d='M246.61 85.534c4.181-2.895 6.087-6.11 6.89-8.83-.201-4.073-1.217-4.704-1.217-4.704s-8.506 7.872-7.733 10.59c.176.625.304 2.26.386 4.41a9.872 9.872 0 011.674-1.466zm-13.86 55.907c1.751 5.207 10.505-3.968 10.756-7.934.16-2.538 2.984-12.487 4.994-19.324a21.418 21.418 0 00-2.492-5.466 19.383 19.383 0 01-.964-1.717c-.949 2.312-4.76 11.79-4.539 14.609.252 3.224-1.502 7.933-1.502 7.933s-8.003 6.691-6.253 11.899z'
							fill='#000'
						/>
						<path
							d='M252.276 71s2.754 1.742 0 18.417l-1.752 17.92s-6.758 22.151-7.009 26.134c-.252 3.984-9.009 13.189-10.764 7.964-1.754-5.225 6.258-11.947 6.258-11.947s1.751-4.728 1.503-7.964c-.249-3.237 4.755-15.181 4.755-15.181s.251-21.9-.5-24.64C244.015 78.964 252.276 71 252.276 71z'
							fill='#FDC2CC'
						/>
						<path
							opacity='.1'
							d='M215.924 70s-3.204.743 0 17.319l1.972 18.062s4.436 25.978 4.189 28.953c-.248 2.974 9.612 10.639 10.349 6.433.737-4.205-4.929-11.133-4.929-11.133s-2.47-5.451-2.47-15.597l-.492-8.165-3.446-29.438L215.924 70z'
							fill='#000'
						/>
						<path
							d='M215.924 70s-3.204.743 0 17.319l1.972 18.062s4.436 25.978 4.189 28.953c-.248 2.974 9.612 10.639 10.349 6.433.737-4.205-4.929-11.133-4.929-11.133s-2.464-5.443-2.464-15.588l-.492-8.165-3.443-29.447L215.924 70z'
							fill='#FDC2CC'
						/>
						<path
							opacity='.1'
							d='M213.572 69.832s-1.453 8.01 8.706 10.765c10.16 2.755-1.209-9.516-1.209-9.516s-3.869-6.004-7.497-1.249z'
							fill='#000'
						/>
						<path
							d='M214.571 69.834s-1.449 8.008 8.708 10.763c10.157 2.755-1.209-9.515-1.209-9.515s-3.871-6.007-7.499-1.248z'
							fill='#D39999'
						/>
						<path
							opacity='.1'
							d='M253.428 69.832s1.453 8.01-8.706 10.765c-10.159 2.755 1.207-9.516 1.207-9.516s3.859-6.004 7.499-1.249z'
							fill='#000'
						/>
						<path
							d='M253.427 69.834s1.463 8.008-8.702 10.763c-10.166 2.755 1.208-9.515 1.208-9.515s3.867-6.007 7.494-1.248z'
							fill='#D39999'
						/>
						<path
							opacity='.1'
							d='M231.5 56.965c1.358.403 2.878-2.834 4.483-2.834 1.7 0 3.302 3.465 4.72 2.73A44.055 44.055 0 01242.5 50l-10.945.982c.448 1.933.291 4.087-.055 5.983z'
							fill='#000'
						/>
						<path
							d='M236 58c5.799 0 10.5-4.701 10.5-10.5S241.799 37 236 37s-10.5 4.701-10.5 10.5S230.201 58 236 58z'
							fill='#FDC2CC'
						/>
						<path
							opacity='.1'
							d='M222.117 43.103c.739 1.035 1.904 1.763 2.988 2.551a32.828 32.828 0 013.79 3.154 11.15 11.15 0 012.119 2.61c.843 1.564.955 3.334 1.055 5.056l1.032 17.792c.068 1.176.136 2.378-.166 3.528a11.993 11.993 0 01-1.279 2.786c-1.363 2.404-2.764 4.856-4.957 6.76-.733.633-1.626 1.45-1.239 2.279.313.667 1.277.882 2.105.979 3.473.464 7.321.86 10.245-.823 1.102-.635 2.016-1.547 3.251-1.94 1.72-.544 3.618.023 5.451.02 1.945 0 3.801-.644 5.616-1.279a2.01 2.01 0 00.922-.517c.145-.209.235-.45.263-.702.275-1.444.535-2.94.086-4.354-.488-1.531-1.774-2.857-1.919-4.438-.189-2.199 1.851-3.989 3.317-5.797 3.121-3.847 3.816-9.388.612-13.183-1.653-1.957-2.17-4.068-3.598-6.152-1.306-1.908-1.554-4.197-1.868-6.396a77.644 77.644 0 00-1.602-8.122c-.198-.787-1.3-1.27-1.847-1.925-1.058-1.264-4.138-1.22-5.912-1.502-2.985-.47-6.207-.911-8.935.256-1.892.811-3.252 2.292-4.73 3.595-2.092 1.857-7.171 2.44-4.8 5.764z'
							fill='#000'
						/>
						<path
							d='M222.118 42.103c.739 1.035 1.903 1.763 2.988 2.551a32.836 32.836 0 013.788 3.16 11.152 11.152 0 012.119 2.61c.842 1.564.954 3.334 1.055 5.056l1.04 17.786c.068 1.176.136 2.378-.166 3.528a11.993 11.993 0 01-1.279 2.786c-1.363 2.404-2.763 4.856-4.956 6.76-.733.633-1.625 1.45-1.238 2.279.313.667 1.277.882 2.104.979 3.472.464 7.32.86 10.242-.823 1.102-.635 2.015-1.547 3.251-1.94 1.719-.544 3.617.023 5.449.02 1.944 0 3.8-.644 5.614-1.279a2.01 2.01 0 00.922-.517c.145-.209.235-.45.263-.702.275-1.444.535-2.94.086-4.354-.488-1.531-1.773-2.857-1.918-4.438-.189-2.199 1.85-3.989 3.316-5.797 3.12-3.847 3.815-9.388.611-13.183-1.652-1.957-2.169-4.068-3.596-6.152-1.306-1.908-1.554-4.197-1.867-6.396a78.165 78.165 0 00-1.602-8.122c-.198-.787-1.3-1.27-1.847-1.925-1.058-1.264-4.137-1.22-5.91-1.502-2.985-.47-6.206-.911-8.933.256-1.891.811-3.251 2.292-4.728 3.595-2.116 1.857-7.178 2.44-4.808 5.764z'
							fill='#865A61'
						/>
						<defs>
							<linearGradient
								id='paint0_linear'
								x1='316.49'
								y1='194.997'
								x2='316.49'
								y2='40.007'
								gradientUnits='userSpaceOnUse'
							>
								<stop stopColor='gray' stopOpacity='.25' />
								<stop offset='.54' stopColor='gray' stopOpacity='.12' />
								<stop offset='1' stopColor='gray' stopOpacity='.1' />
							</linearGradient>
							<linearGradient
								id='paint1_linear'
								x1='257.501'
								y1='220.026'
								x2='257.501'
								y2='31.012'
								gradientUnits='userSpaceOnUse'
							>
								<stop stopColor='gray' stopOpacity='.25' />
								<stop offset='.54' stopColor='gray' stopOpacity='.12' />
								<stop offset='1' stopColor='gray' stopOpacity='.1' />
							</linearGradient>
						</defs>
					</svg>
					<div className={css(styleSheet.bookOfBidniz)}>Book of bidniz</div>
				</div>
				<div className={css(styleSheet.inputContainer)}>
					<AutoCompleteSearchField
						leftAccessory={
							<span className={css(styleSheet.iconSpan)}>
								<SearchIcon fillColor='#FFF' />
							</span>
						}
						anchorClassName={css(styleSheet.searchBox)}
						contentStyles={[styleSheet.autocompleteBoxContent]}
						dropdownContentClassName={css(styleSheet.autocompleteBox)}
						inputId='employeeSearchBox1'
						inputProps={{ placeholder: 'Search Success Peep' }}
						onItemSelected={this.onAutocompleteItemSelectedCustomerSuccessRep}
						resultsLimit={5}
						type={Api.ResourceAutoCompleteViewModelType.User}
					/>
				</div>
				<div className={css(styleSheet.or)}>OR</div>
				<div className={css(styleSheet.checkYoself)} onClick={this.onCheckYourselfClicked}>
					{'Check yoself >>>'}
				</div>
			</div>
		);
	}

	private onAutocompleteItemSelectedCustomerSuccessRep = (user: Api.IUser) => {
		this.props.history.push(`/accounts?accountFilter=ownedBy:${user.id}`);
	};

	private onCheckYourselfClicked = () => {
		const { history, userSession } = this.props;
		history.push(`/accounts?accountFilter=ownedBy:${userSession.user.id}`);
	};
}

const BookOfBusinessSectionAsObserver = observer(_BookOfBusinessSection);
const BookOfBusinessSectionWithRouter = withRouter(BookOfBusinessSectionAsObserver);
export const BookOfBusinessSection = inject(UserSessionViewModelKey)(BookOfBusinessSectionWithRouter);
